import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Card, Spinner, EmptyState } from "@/components/bits";
import StatusBadge from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Recycle, CheckCircle2 } from "lucide-react";
import PartPhotos from "@/components/PartPhotos";

const SAL_STATUS = { "Pending Receipt": "REVIEW", "In Salvage Stock": "COMPLETE", "Returned Insurance": "ORDERED", "Transferred": "ORDERED" };

export default function Salvage() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); api.get("/warehouse/salvage").then((r) => setRows(r.data)).finally(() => setLoading(false)); };
  useEffect(load, []);
  const canConfirm = user.role === "owner" || user.role === "warehouse_out";

  const confirm = async (id) => {
    try { await api.post(`/warehouse/salvage/${id}/confirm`); toast.success("Salvage diterima ke stock"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div>
      <PageHeader title="Stok Salvage" subtitle="Part lama hasil pemasangan. Confirm untuk masuk stock salvage." />
      {loading ? <Spinner /> : rows.length === 0 ? <EmptyState title="Belum ada salvage" icon={Recycle} /> : (
        <div className="grid gap-2">
          {rows.map((s) => (
            <Card key={s.id} className="p-3" data-testid={`salvage-${s.id}`}>
              <div className="flex items-center justify-between gap-2">
                <div>
                  <div className="font-mono-data font-semibold">{s.nopol} • {s.part_number || "—"}</div>
                  <div className="text-sm text-gray-600">{s.part_name} ×{s.qty}</div>
                  <div className="text-xs text-gray-400">{s.insurance || "—"} • {(s.installed_date || "").slice(0, 10)} • {s.condition}</div>
                </div>
                <div className="flex items-center gap-2">
                  <StatusBadge status={SAL_STATUS[s.status] || "WAITING"} />
                  <span className="text-xs text-gray-500 hidden sm:inline">{s.status}</span>
                  {canConfirm && s.status === "Pending Receipt" && (
                    <Button size="sm" variant="outline" onClick={() => confirm(s.id)} data-testid={`confirm-salvage-${s.id}`}><CheckCircle2 size={14} className="mr-1" />Confirm Received</Button>
                  )}
                </div>
              </div>
              {s.part_line_id && s.status === "Pending Receipt" && (
                <div className="mt-3 pt-3 border-t border-gray-100">
                  <div className="text-[11px] font-semibold uppercase tracking-wide text-amber-600 mb-1">Foto Akhir (WAJIB sebelum confirm, kamera)</div>
                  <PartPhotos partLineId={s.part_line_id} phase="FINAL" canUpload={canConfirm} compact maxPhotos={5}
                    meta={{ nopol: s.nopol, claim_number: s.claim_number, part_name: s.part_name, part_number: s.part_number }} />
                </div>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
